module.exports = __webpack_public_path__ + "img/banner7.4950ee15.png";